import React from 'react';
import ImageSliderComponent from './ImageSliderComponent';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function PosterCardLarge(props) {
  const isMobileView = useMediaQuery('(max-width:500px)');
  const isTabletView = useMediaQuery('(min-width:900px)');

  return (
    <div style={{
      width: isMobileView ? '100vw' : isTabletView ? '38vw' : '32vw',
      marginLeft: isMobileView ? 0 : '240px',
      height: '100%',
    }}>
      <ImageSliderComponent imageDisplayUrls={props.imageDisplayUrls} />
    </div>
  );
}
